import { createReducer, on } from "@ngrx/store";
import { addActividades, addActividadesError, clearActividades, deleteActividad, updateActividad } from "../actions/tipoActividad.actions";
import { initialActividadState } from "../../core/interfaces/models/tipoActividad.interface";

 export const actividadReducer = createReducer(
  initialActividadState,
  on(addActividades, (_, { actividadesState }) => (
    actividadesState
  )),
  on(addActividadesError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateActividad, (state, { tipoActividad }) => ({
    ...state,
    actividades: state.actividades.map(u =>
      u.id === tipoActividad.id ? tipoActividad : u
    )
  })),
  on(deleteActividad, (state, { id }) => ({
    ...state,
    actividades: state.actividades.filter(u => u.id !== id)
  })),

  on(clearActividades, () => initialActividadState)
);
 